import { site } from '@yola/ws-sdk';
import segment from 'src/js/modules/analytics/segment';

const {
  track,
  constants: { events, triggerIds },
} = segment;

const trackBusinessCategorySelected = ({ category, archetype }) => {
  const siteId = site.accessors.getSiteId();

  track(events.BUSINESS_CATEGORY_SELECTED, {
    siteId,
    stepId: null,
    businessCategory: category,
    archetypeId: archetype,
    source: triggerIds.WEBSITE_SETTINGS,
  });
};

export default trackBusinessCategorySelected;
